var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn hover:text-white w-40",class:_vm.buttonType,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.addOrRemove.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.button_text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }